export default class ConnectionUnavailableError extends Error {
  static CODE = 'connection-unavailable'

  constructor(...args) {
    super('No internet connection')
    this.code = ConnectionUnavailableError.CODE
  }
}
